import Cookies from 'js-cookie';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export function connectToLiveAlarms() {
  try {
    loginfo();
    return new EventSource(
      `${process.env.PUBLIC_API_URL}/alarmNotifier_Event?token=${encodeURIComponent(
        Cookies.get('accessToken'),
      )}`,
    );
  } catch (error) {
    console.error('connectToLiveAlarms failed.', error);
  }
}
